import React, {forwardRef} from 'react';
import {StyleSheet, Text, TextProps, TextStyle} from 'react-native';
import glyphMap from 'react-native-vector-icons/glyphmaps/MaterialCommunityIcons.json';

type Props = TextProps & {
  name: string;
  size?: number;
  color?: string;
  direction?: 'rtl' | 'ltr';
};

const MaterialCommunityIcons = forwardRef<React.ElementRef<typeof Text>, Props>(
  ({name, size = 12, color, direction, style, ...props}, ref) => {
    const codePoint = glyphMap[name as keyof typeof glyphMap];
    const glyph = typeof codePoint === 'number' ? String.fromCodePoint(codePoint) : '?';
    const iconStyle: TextStyle = {
      color,
      fontSize: size,
      lineHeight: size,
      transform: direction ? [{scaleX: direction === 'rtl' ? -1 : 1}] : undefined,
    };

    return (
      <Text ref={ref} selectable={false} {...props} style={[styles.icon, iconStyle, style]}>
        {glyph}
      </Text>
    );
  },
);

MaterialCommunityIcons.displayName = 'MaterialCommunityIcons';

const styles = StyleSheet.create({
  icon: {
    fontFamily: 'MaterialCommunityIcons',
    fontStyle: 'normal',
    fontWeight: 'normal',
  },
});

export default MaterialCommunityIcons;
